import { getPageRoute } from '@/router/common';
const viewPath = 'custom/allergan/views';
const allergan = ['InstitutionalManage'].map((r) =>
  typeof r === 'string' ? getPageRoute([r], viewPath) : getPageRoute(r, viewPath),
);
export default allergan;
